import { BlocRecherche } from "./BlocRecherche";


export class Filtre {

  public Ident: string;

  public Titre: string;

  public Description: string;

  public Image: string;

  public ListBloc: Array<BlocRecherche>;

  public HasImage: boolean;

  public ExtensionImage: string;

  // Sert uniquement pour l'affichage
  public EditMode: boolean;

  public BlocTrainingLocation: BlocRecherche;

  public BlocTrainingName: BlocRecherche;

  public IsActive: boolean;

  public Visibility: boolean;

  public Order: number;

  public Link: string;

  constructor() {
    this.BlocTrainingLocation = new BlocRecherche();
    this.BlocTrainingName = new BlocRecherche();
    this.ListBloc = new Array<BlocRecherche>();
  }
}


